import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Connects via data-controller="mixtapes" in the html
export default class extends Controller {

  static targets = ["sortableList", "form", "privacyToggle"]
  static values = {
    updated: Boolean,
    payload: Object,
  }

  connect() {
    this.initializeSortable()
    this.onMixtapesForm = this.loadMixbench.bind(this)
    this.onMixtapesEdit = this.loadEditForm.bind(this)
    this.onMixtapesDelete = this.loadConfirmDelete.bind(this)

    document.addEventListener("mixtapes:form", this.onMixtapesForm)
    document.addEventListener("mixtapes:edit", this.onMixtapesEdit)
    document.addEventListener("mixtapes:confirm_delete", this.onMixtapesDelete)

    const isEdit = this.element.dataset.mode === "edit"
    if (this.hasFormTarget && !isEdit) this.clearForm()

    if (this.hasPrivacyToggleTarget) {
      this.onPrivacyChange = this.togglePrivacyLabels.bind(this);
      this.privacyToggleTarget.addEventListener("change", this.onPrivacyChange);
      this.togglePrivacyLabels();
    }
    if (this.updatedValue && this.hasPayloadValue) {
      document.dispatchEvent(new CustomEvent("mixtape:updated", { detail: this.payloadValue }))
    }

    // Close the modal after 2 seconds if the element has the class "close-modal"
    if (this.element.classList.contains("close-modal")) {
      setTimeout(() => {
        const modal = document.querySelector("[data-controller='modal']");
        const modalController = this.application.getControllerForElementAndIdentifier(modal, "modal");
        modalController?.close();
      }, 2000);
    }
  }

  disconnect() {
    document.removeEventListener("mixtapes:form", this.onMixtapesForm)
    document.removeEventListener("mixtapes:edit", this.onMixtapesEdit)
    document.removeEventListener("mixtapes:confirm_delete", this.onMixtapesDelete)

    if (this.hasPrivacyToggleTarget && this.onPrivacyChange) {
      this.privacyToggleTarget.removeEventListener("change", this.onPrivacyChange);
    }

  }

  loadMixbench(event) {
    const { songVersionId } = event.detail
    this.openModal("small")
    Turbo.visit(`/mixbench/${songVersionId}`, { frame: "active-modal-content" })
  }

  loadEditForm(event) {
    const { mixtapeId } = event.detail
    this.openModal("small")
    Turbo.visit(`/mixtapes/${mixtapeId}/edit`, { frame: "active-modal-content" })
  }

  loadConfirmDelete(event) {
    const { mixtapeId } = event.detail
    this.openModal("small")
    Turbo.visit(`/mixtapes/${mixtapeId}/confirm_delete`, { frame: "active-modal-content" })
  }

  openModal(size = "small") {
    const modal = document.querySelector("[data-controller='modal']")
    if (!modal) return
    const modalController = this.application.getControllerForElementAndIdentifier(modal, "modal")
    const openEvent = new CustomEvent("modal:open", { detail: { size } })
    modalController?.open(openEvent)
  }

  clearForm(event) {
    this.formTarget.querySelectorAll('#mixtape-name, textarea').forEach(input => {
      input.value = ''
    })
  }

  togglePrivacyLabels() {
    const isSecret = this.hasPrivacyToggleTarget ? this.privacyToggleTarget.checked : false;

    const publicLabel = document.getElementById("privacy-public");
    const secretLabel = document.getElementById("privacy-secret");

    if (publicLabel && secretLabel) {
      publicLabel.classList.toggle("hidden", isSecret);
      secretLabel.classList.toggle("hidden", !isSecret);
    }

    const label = document.querySelector("label[for='privacy']");
    const publicIcon = label?.querySelector(".icon.public");
    const secretIcon = label?.querySelector(".icon.secret");

    if (publicIcon && secretIcon) {
      publicIcon.classList.toggle("hidden", isSecret);
      secretIcon.classList.toggle("hidden", !isSecret);
    }
  }

  initializeSortable() {
    if (this.hasSortableListTarget) {
      this.sortable = new Sortable(this.sortableListTarget, {
        handle: '.icon-left',
        animation: 200,
        ontouchmove: this.element.classList.add('dragging'),
        ontouchend: this.element.classList.remove('dragging'),
        onEnd: this.updateOrder.bind(this)
      })
    }
  }

  updateOrder(event) {
    const { oldIndex, newIndex } = event
    const mixtapeId = event.item.dataset.mixtapeId
    console.log(event.item.dataset)

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    fetch('/mixtapes/reorder', {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken
      },
      body: JSON.stringify({
        mixtape_id: mixtapeId,
        old_position: oldIndex,
        new_position: newIndex
      })
    })
    .then(response => {
      if (!response.ok) {
        console.log(response)
        throw new Error('Reordering failed. See console response object.')
      }
      return response.json()
    })
    .catch(error => {
      console.error('Reordering error:', error)
    })
  }
}
